<div class="py-[30px]">
  <div class="v4-layout-form">
    <div class="v4-layout-form-title">
      {{ "property-property_detail-channels_html_关联的房源" | translate }}
      <!-- Linked Listings -->
    </div>
    <div class="">
      <nz-table
        #nzTable
        class="v4-layout-list"
        [nzFrontPagination]="false"
        [nzData]="listOfLinkedListings"
        [nzTotal]="total"
        [(nzPageIndex)]="page"
        [nzPageSize]="pageSize"
        nzPaginationType="small"
        [nzShowTotal]="totalTpl">
        <thead>
          <tr>
            <th class="w-1/2">
              {{ "word.house_list" | translate }}
              <!-- Listings -->
            </th>
            <th class="w-1/2"></th>
          </tr>
        </thead>
        <tbody class="v4-layout-list-body">
          <tr *ngFor="let house of nzTable.data">
            <td>
              <div class="flex flex-row items-center break-all">
                <div class="relative mr-2">
                  <img
                    class="absolute left-1 top-1 w-[18px] h-[18px] rounded-full"
                    [src]="(house.thirdparty_type | thirdparty)?.icon_color_bg"
                    alt="" />
                  <span class="absolute right-1 top-1 count">{{ house.inventory }}</span>
                  <img
                    class="w-20 h-14 rounded-[10px]"
                    src="/assets/status/placeholder.png"
                    hostPlaceholder
                    [delaySrc]="house?.picture?.small_url"
                    alt="" />
                </div>
                <div>
                  <div class="ellipsis-line-2 text-m mb-1">{{ house.title }}</div>
                  <div class="text-s">{{ house.thirdparty_username }}</div>
                </div>
              </div>
            </td>
            <td>
              <div class="space-nowrap text-right">
                <a class="mr-2" [href]="house.housing_link" target="_blank">
                  <button nz-button>{{ "word.preview" | translate }}</button>
                </a>

                <button class="mr-2" nz-button (click)="onUnbind(house)">{{ "word.unbind" | translate }}</button>

                <button *ngIf="house.is_shelf && house.sync_status !== -1" nz-button (click)="onUnshelf(house)">
                  <!-- 下架 -->
                  {{ "house.pull_off_shelves" | translate }}
                </button>
                <button *ngIf="!house.is_shelf && house.sync_status !== -1" nz-button (click)="onShelf(house)">
                  <!-- 上架 -->
                  {{ "house.put_on_shelves" | translate }}
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </nz-table>
      <ng-template #totalTpl>
        {{ "component-page_html_总数" | translate: { number: total } }}
        <!-- {{ total }} items -->
      </ng-template>
    </div>
  </div>

  <div class="v4-layout-form">
    <div class="v4-layout-form-title">
      {{ "property-property_detail-channels_html_关联的ical" | translate }}
      <!-- iCal Linked -->
    </div>
    <div class="">
      <!-- 本房间ical -->
      <nz-table
        #pIcal
        [nzData]="icalAddr ? [{ ical: icalAddr }] : []"
        class="v4-layout-list"
        [nzShowPagination]="false">
        <thead>
          <tr>
            <th>
              {{ "property-property_detail-channels_html_房源ical" | translate }}
              <!-- iCal of this property -->
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of pIcal.data">
            <td>{{ row.ical }}</td>
            <td>
              <button hostClipboard [clipboardData]="row.ical" nz-button nzType="primary">
                {{ "word.copy" | translate }}
              </button>
            </td>
          </tr>
        </tbody>
      </nz-table>

      <!-- 第三方的ical -->
      <nz-table #icalTable class="v4-layout-list" [nzShowPagination]="false" [nzData]="listOfLinkedIcal">
        <thead>
          <tr>
            <th class="w-1/2">
              {{ "property-property_detail-channels_html_渠道ical" | translate }}
              <!-- {{ "property_detail.channel_management.ical.modal.add_label" | translate }} -->
              <!-- iCal URL -->
            </th>
            <th class="w-1/2"></th>
          </tr>
        </thead>
        <tbody class="v4-layout-list-body">
          <tr *ngFor="let data of icalTable.data">
            <td>
              {{ data.url }}
            </td>
            <td>
              <div class="text-right">
                <button class="mr-2" nz-button (click)="onClickDeleteIcal(data.id)">
                  {{ "word.unbind" | translate }}
                </button>
              </div>
            </td>
          </tr>

          <!-- <tr>
            <td [colSpan]="2">
              <button nz-button nzSize="large" nzType="primary" (click)="onClickAddiCal()">
                {{ 'property-property_detail-channels_html_添加ical' | translate }}
                + iCal
              </button>
            </td>
          </tr> -->
        </tbody>
      </nz-table>
      <nz-table>
        <thead>
          <tr>
            <th nzAlign="left" [colSpan]="2">
              <button nz-button nzSize="large" nzType="primary" (click)="onClickAddiCal()">
                {{ "property-property_detail-channels_html_添加ical" | translate }}
                <!-- + iCal -->
              </button>
            </th>
          </tr>
        </thead>
      </nz-table>
    </div>
  </div>
</div>

<ng-template #icalAddTpl>
  <div class="mb-[30px]">
    <nz-alert nzShowIcon [nzMessage]="'property_detail.channel_management.ical.modal.add_tip' | translate"></nz-alert>
  </div>
  <div class="v4-layout-form" [formGroup]="icalAddForm">
    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        <!--        iCal地址-->
        {{ "property_detail.channel_management.ical.modal.add_label" | translate }}
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <input
            type="text"
            nz-input
            nzSize="large"
            [placeholder]="'property_detail.channel_management.ical.modal.add_placeholder' | translate"
            formControlName="url" />
        </div>
      </div>
    </div>
  </div>
</ng-template>
